import claimBtnImg from "@assets/web-v3-images/free-bid-btn-bg.png";
import iconFreeBid from "@assets/web-v3-images/free-bid-icon.png";
import bgFreeBidbottom from "@assets/web-v3-images/free-bid-popup-bg-bottom.png";
import bgFreeBidCenter from "@assets/web-v3-images/free-bid-popup-bg-center.png";
import bgFreeBidTop from "@assets/web-v3-images/free-bid-popup-bg-top.png";
import imgExit from "@assets/web-v3-images/icons/exits.png";
import { Text } from "@radix-ui/themes";
import { useTranslation } from 'react-i18next';
import Popups from "./popups";

const Titles = () => {
  const { t } = useTranslation();
  return (
    <svg
      viewBox="0 0 600 120"
      preserveAspectRatio="xMidYMid meet"
      className="w-full h-[65px] sm:h-[100px]"
    >
      <defs>
        <path id="curve" d="M 80 90 Q 300 30 520 90" />
      </defs>

      <text
        fontWeight="900"
        fill="#FFFBE8"
        stroke="#C73618"
        strokeWidth="6"
        paintOrder="stroke"
        className="text-[30px] sm:text-[30px]"
      >
        <textPath href="#curve" startOffset="50%" textAnchor="middle">
          {t('user_guide.welcome_to_shwe_deal')}
        </textPath>
      </text>
    </svg>
  );
};

// Controlled by ModalRender — all frequency/session gating is handled by popupManager.
// message: câu BE trả trong /front/user/current, chỉ có khi hôm nay user được cấp
// Free Turn. Không có message (popup hiện vì còn freeBidCount > 0) thì dùng câu
// "đã nhận X Free Turn" của FE, cùng nghĩa với câu BE dùng cho freeBidCount.
export default function ModalBidFree({ open = true, onClose = () => { }, message, freeBidCount }) {
  const { t } = useTranslation()
  const content = message
    || (Number(freeBidCount) > 0
      ? t('user_guide.you_have_received_free_bids').replace('_X_', freeBidCount)
      : '');

  const handleOpenChange = (nextOpen) => {
    if (!nextOpen) onClose();
  };

  return (
    <Popups
      open={open}
      onOpenChange={handleOpenChange}
      className="!bg-transparent !shadow-none !p-0 mx-auto !-mt-32"
    >
      {/* Ảnh nền đã bao gồm tia sáng, dải ruy băng và tiêu đề "Welcome to
          ShweDeal!" nên chỉ cần phủ nội dung lên trên theo tỉ lệ của ảnh
          (880x1383): ruy băng ở 25% chiều cao, khung kem bên trong nằm trong
          khoảng 12.5%..87.5% ngang và 29%..91% dọc. */}
      {/* Popup luôn gọn trong 1 màn hình: chặn CHIỀU CAO của ảnh nền — ảnh là
          replaced element nên max-height tự co bề rộng đúng tỉ lệ — và wrapper
          w-fit ôm sát ảnh để các lớp phủ định vị theo % vẫn khớp. Nhờ đó vùng
          scroll của Radix (.rt-BaseDialogScroll) không bao giờ bị tràn nên
          không xuất hiện thanh cuộn, và margin:auto của nó giữ popup đứng giữa
          màn hình. Inline maxHeight dùng svh để trừ thanh công cụ trình duyệt
          mobile; trình duyệt cũ không hiểu svh sẽ bỏ qua và rơi về max-h-[85vh]
          của class. */}
      <div className="relative mx-auto w-full max-w-[650px] flex flex-col">
        {/* PHẦN TOP: cố định, không co giãn */}
        <div className="relative shrink-0">
          <img src={bgFreeBidTop} alt="" className="block w-full h-auto" />
          <div className="absolute z-10 bottom-[18%] left-1/2 -translate-x-1/2 w-full flex justify-center z-50">
            <Titles />
          </div>
          <img
            src={imgExit}
            alt=""
            onClick={() => handleOpenChange(false)}
            className="absolute top-[70%] right-[4%] w-[12%] h-auto -translate-y-1/2 cursor-pointer btn-click-active z-51"
          />
          <img
            src={iconFreeBid}
            alt=""
            className="absolute left-1/2 -translate-x-1/2 -bottom-18 sm:-bottom-25 translate-y-1/4 w-[55%] h-auto z-10"
          />
        </div>
        {/* PHẦN CENTER: co giãn theo nội dung */}
        <div className="relative flex-1 min-h-[350px]">
          <img
            src={bgFreeBidCenter}
            alt=""
            className="absolute -top-1 inset-0 w-full h-full object-fill"
          />

          <div className="relative z-10 flex flex-col items-center justify-center min-h-full text-center px-[14%] py-[6%] pt-32 sm:pt-45">
            <Text
              as="p"
              className="
          w-full
          text-[#713B12]
          font-medium
          whitespace-pre-line
          leading-snug
          text-center
          text-[13px]
          sm:text-[16px]
          md:text-[17px]
          px-2 sm:px-5
        "
            >
              {content}
            </Text>

            <button
              type="button"
              onClick={onClose}
              className="relative w-[80%] mt-6 mx-auto outline-none cursor-pointer btn-click-active"
            >
              <img src={claimBtnImg} alt="" className="block w-full h-auto" />
              <Text
                as="span"
                className="absolute inset-0 flex items-center justify-center select-none
            text-white font-semibold
            text-[16px] sm:text-[22px] md:text-[24px] lg:text-[24px] xl:text-[24px]"
              >
                {t('claim')}
              </Text>
            </button>
          </div>
        </div>

        {/* PHẦN BOTTOM: cố định, không co giãn — giống top */}
        <div className="relative shrink-0 -mt-[5px]">
          <img src={bgFreeBidbottom} alt="" className="block w-full h-auto" />
        </div>
      </div>
    </Popups>
  );
}
